import {createTableState, normalizePagination} from '@/core/services/Helper'

// Birleşik etiket (tag) modülü — type ile ölçeklenir: product | order | user
const state = () => ({
    table: createTableState(),
    filterData: undefined,
})

const getters = {}

const actions = {
    // kayıtları getir (server-side pagination, type ile filtrelenir)
    async get({state, commit}, {type, page, filterData}) {
        commit('setLoading', true)

        state.filterData = filterData

        let params = {
            type,
            page: page?.current,
            page_limit: page?.pageSize,
        }

        if (state.filterData) {
            params = {...params, ...state.filterData}
        }

        const res = await this._vm.axios.get(this._vm.endpoint.get('tag'), {params})

        const {data, meta} = res.data

        commit('updateTableData', data)
        commit('updatePagination', normalizePagination(meta))

        setTimeout(() => {
            commit('setLoading', false)
        }, 250)
    },

    // seçenek listesi — tipe göre tüm etiketleri düz dizi olarak döner (dropdown vb. için)
    async list(_, {type, filterData} = {}) {
        const params = {type, page_limit: 1000, ...(filterData || {})}
        const res = await this._vm.axios.get(this._vm.endpoint.get('tag'), {params})
        return res.data.data || []
    },

    // tekil getir (taggable sayısıyla birlikte)
    async show({commit}, {id}) {
        const response = await this._vm.axios.get(this._vm.endpoint.get('tag') + '/' + id)
        return response.data.data
    },

    // yeni etiket oluştur
    async create({commit}, {data}) {
        const response = await this._vm.axios.post(this._vm.endpoint.get('tag'), data)
        return response.data
    },

    // etiket güncelle
    async update({commit}, {id, data}) {
        const response = await this._vm.axios.put(this._vm.endpoint.get('tag') + '/' + id, data)
        return response.data
    },

    // etiket(ler) sil
    async delete({commit}, {id}) {
        let successDeleted = []
        if (!id || id.length === 0) {
            this._vm.$message.warning(this._vm.$t('messages.selectRow'))
            return successDeleted
        }
        for (let i = 0; i < id.length; i++) {
            const {data} = await this._vm.axios.delete(this._vm.endpoint.get('tag') + '/' + id[i])
            if (data.status) {
                successDeleted.push(id[i])
            } else {
                this._vm.$message.error(data.message)
            }
        }
        return successDeleted
    },
}

const mutations = {
    setLoading(state, val) {
        state.table.loading = val
    },
    updatePagination(state, pagination) {
        state.table.pagination = pagination
    },
    updateTableData(state, data) {
        state.table.data = data
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
